var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.login == 1)?_c('PadorConfirm'):_c('LoginFloatConfirm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }